export const GET_NOCONFORMIDADES_REQUEST = 'GET_NOCONFORMIDADES_REQUEST';
export const GET_NOCONFORMIDADES_SUCCESS = 'GET_NOCONFORMIDADES_SUCCESS';
export const GET_NOCONFORMIDADES_FAILURE = 'GET_NOCONFORMIDADES_FAILURE';
export const SELECCIONAR_NO_CONFORMIDAD = 'SELECCIONAR_NO_CONFORMIDAD';
export const GET_NOCONFORMIDAD_REQUEST = 'GET_NOCONFORMIDAD_REQUEST';
export const CREATE_NOCONFORMIDAD_REQUEST = 'CREATE_NOCONFORMIDAD_REQUEST';
export const SET_MOSTRAR_BOTON_GUARDAR = 'SET_MOSTRAR_BOTON_GUARDAR';
export const SET_MOSTRAR_BOTON_TIPOLOGIAS = 'SET_MOSTRAR_BOTON_TIPOLOGIAS';
export const SET_ACTIVE_TAB_FORM = 'SET_ACTIVE_TAB_FORM';
export const GET_NOCONFORMIDAD_SUCCESS = 'GET_NOCONFORMIDAD_SUCCESS';
export const UPDATE_NOCONFORMIDAD_REQUEST = 'UPDATE_NOCONFORMIDAD_REQUEST';
export const RESET_NO_CONFORMIDADES = 'RESET_NO_CONFORMIDADES';
export const NO_CONFORMIDAD_DESELECT = 'NO_CONFORMIDAD@DESELECCIONAR';
export const SET_MOSTRAR_BOTON_AFECTADOS = 'SET_MOSTRAR_BOTON_AFECTADOS';
export const DELETE_PHOTO_NOCONFORMIDAD_REQUEST = 'DELETE_PHOTO_NOCONFORMIDAD_REQUEST';
export const SET_MOSTRAR_BARRA_BOTONES_FORM_NC = 'SET_MOSTRAR_BARRA_BOTONES_FORM_NC';
